import { useEffect, useState } from "react";

const Logout = () => {
  const [showConfirmation, setShowConfirmation] = useState(true);

  useEffect(() => {
    // Show confirmation dialog when component mounts
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("homeshiksha-jwt");
    window.location.href = "/";
  };

  const handleCancel = () => {
    // Go back to previous page or dashboard
    window.history.back();
  };

  if (showConfirmation) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.1)",
        }}>
        <div
          style={{
            backgroundColor: "white",
            padding: "30px",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            textAlign: "center",
            maxWidth: "400px",
            width: "90%",
          }}>
          <h3
            style={{
              marginBottom: "20px",
              color: "#333",
              fontFamily: "Open Sans, sans-serif",
            }}>
            Confirm Logout
          </h3>
          <p
            style={{
              marginBottom: "30px",
              color: "#666",
              fontSize: "16px",
              lineHeight: "1.4",
            }}>
            Are you sure you want to logout? You will need to login again to access your account.
          </p>
          <div style={{ display: "flex", gap: "15px", justifyContent: "center" }}>
            <button
              onClick={handleCancel}
              style={{
                padding: "12px 24px",
                backgroundColor: "#f5f5f5",
                color: "#333",
                border: "1px solid #ddd",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: "600",
              }}>
              Cancel
            </button>
            <button
              onClick={handleLogout}
              style={{
                padding: "12px 24px",
                backgroundColor: "#2B93A5",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: "600",
              }}>
              Logout
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <div>Logging out...</div>;
};

export default Logout;
